export const getBandolData = () => ({
  name: "Bandol",
  region: "Provence",
  country: "France",
  description: "Bandol est une appellation prestigieuse de Provence, réputée pour ses vins rouges puissants à base de Mourvèdre ainsi que ses rosés élégants.",
  type: "subregion",
  area: "1,500 ha",
  production: "50,000 hectolitres",
  mapAreas: [
    { region: "Bandol", x: 5.75, y: 43.15, color: "#4B164C", size: 4 }
  ],
  characteristics: {
    climate: "Climat méditerranéen, étés chauds et secs",
    soil: "Sols argilo-calcaires, caillouteux",
    viticulture: "Viticulture traditionnelle, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges puissants, structurés, à base de Mourvèdre",
    white: "Vins blancs frais et aromatiques",
    rose: "Rosés élégants, fruités et structurés"
  },
  history: "La viticulture à Bandol remonte à l'époque romaine. L'appellation est reconnue pour ses vins de garde et son cépage phare, le Mourvèdre.",
  foodPairing: "Viandes grillées, agneau, cuisine méditerranéenne, fromages affinés",
  grapeVarieties: {
    red: ["Mourvèdre", "Grenache", "Cinsault"],
    white: ["Clairette", "Ugni Blanc", "Bourboulenc"],
    rose: ["Mourvèdre", "Grenache", "Cinsault"]
  },
  subregions: {}
}); 